module.exports = __webpack_public_path__ + "img/camera-corner-top-right.87bc72eb.png";